import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const reposPulseAppBuilder = DataRouterApplicationBuilder.create('repos-pulse')
